import React, { useEffect, useState, memo, useRef } from "react";
import { Link } from "react-router-dom";

import axios from "axios";
import { Skeleton } from "@mui/material";
import ReactMarkdown from "react-markdown";
import { Heart, Heart2, Lock } from "react-iconly";
import { Container, Row, Col } from "react-bootstrap";
import { Book1, Monitor, PlayCircle, Timer } from "iconsax-react";

import videoPoster from "../../../../image/assets/sim-video-poster.png";
import { rateSimApi, toggleSimBookmarkApi } from "../../../../utility/api/apiList";

import useAxios from "../../../../hooks/useAxios";
import convertDateToString from "../../../../libs/convertDateToString";

import VideoPlayerComponent from "../../videoPlayer";

import { TabContentSection } from "../../../../containers/singleSim/styledSimContainer";
import {
  SimWrapper,
  RightContent,
  SimHashtagFilterWrapper,
  LeftContent,
  VideosSelectionWrapper,
  StyledVideoTemplate,
  BottomWrapper,
} from "./styledInfoTab";
import { HashtagLabel } from "../../../../containers/sims/styledSimPage";
import { CardScoreDiv, StyledRating } from "../../singleSimCard/styledSingleSimCard";
import { StyledTooltip } from "../../../../style/base/base";

const SimInfoComponent = ({
  simInfoData,
  bookData,
  isLogin,
  isIframe,
  CheckAccessFunction,
}) => {
  const { error, errorMessage, loading, singleSimDetail: data } = simInfoData;
  const hashtagList = data.hashtag ? data.hashtag : new Array(4).fill("");

  const [isShowVideo, setIsShowVideo] = useState(false);
  const [playingVideo, setPlayingVideo] = useState({
    src: "",
    activeVideo: [false, false, false],
    crossOrigin: false,
  });

  const videosList = [
    {
      id: 0,
      title: "درسنامه",
      src: data.theory_path,
    },
    {
      id: 1,
      title: "راهنما",
      src: data.path,
    },
    {
      id: 2,
      title: "ویدیو",
      src: data.real_video_path,
      subtitle: data.subtitle,
      crossOrigin: "anonymous",
    },
  ];

  const InfoSkeleton = () => {
    return (
      <TabContentSection $info>
        <Container className="pt-5 pb-3 ">
          <SimWrapper className="mb-5">
            <RightContent className="d-grid">
              <Skeleton className="sim-image" />
              <Skeleton className="book-button" height={56} />
              <SimHashtagFilterWrapper>
                {hashtagList.map((hashtag, index) => {
                  return <HashtagLabel key={index} />;
                })}
              </SimHashtagFilterWrapper>
            </RightContent>
            <LeftContent>
              <Row>
                <Col xs={10} lg={6}>
                  <Skeleton className="mb-3" width="45%" />
                </Col>
                <Col xs={2} lg={2} className="text-start order-lg-4">
                  <Skeleton variant="circular" width={24} height={24} />
                </Col>
                <Col xs={12} lg={6} className="order-lg-2">
                  <CardScoreDiv className="d-flex justify-content-end text-muted">
                    <Skeleton width="10%" />
                    <Skeleton width="40%" />
                  </CardScoreDiv>
                </Col>
                <Col xs={12} lg={10} className="order-lg-3">
                  <Skeleton className="description" />
                  <Skeleton className="description" />
                  <Skeleton className="description" />
                </Col>
              </Row>
              <footer className="mt-4">
                <Skeleton width="100px" />
                <Skeleton className="sim-goals" />
                <Skeleton className="sim-goals" />
                <Skeleton className="sim-goals" />
              </footer>
            </LeftContent>
          </SimWrapper>
          <VideosSelectionWrapper className="mt-5">
            <Skeleton width="80%" height={200} className="mx-auto" />
            <Skeleton width="80%" height={200} className="mx-auto" />
            <Skeleton width="80%" height={200} className="mx-auto" />
          </VideosSelectionWrapper>
        </Container>
      </TabContentSection>
    );
  };


  const [autoPlayer, SetautoPlayer] = useState(false);

  const VideoTemplate = ({ id, title, src, isActive, crossOrigin }) => {
    const handlePlayinVideo = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setIsShowVideo(true);
      const newActiveVideo = playingVideo.activeVideo.map((item, index) =>
        index === id ? true : false
      );
      setPlayingVideo({
        src,
        activeVideo: newActiveVideo,
        crossOrigin: crossOrigin && crossOrigin,
      });
      SetautoPlayer(true)
    };
    const checkAccessVideo = isLogin && (data.is_free || data.is_subscribed);
    return (
      <StyledVideoTemplate
        $isActive={isActive}
        className="text-center"
        $disabled={!checkAccessVideo}
      >
        <h6 className="mb-2 mb-md-4">{title}</h6>
        <div
          className="blur-effect mx-auto position-relative"
          onClick={() => (checkAccessVideo && handlePlayinVideo(id)) || null}
        >
          {checkAccessVideo ? (
            <PlayCircle
              variant="Bold"
              color="var(--white-color)"
              size="50"
              className="layer-icon h-100 position-absolute"
            />
          ) : (
            <Lock
              set="bold"
              size="large"
              primaryColor="var(--text-color-muted)"
              className="layer-icon h-100 position-absolute"
            />
          )}
        </div>
      </StyledVideoTemplate>
    );
  };

  const InfoSection = () => {
    const [countScore, setCountScore] = useState(data.count_score);
    const [ratingValue, setRatingValue] = useState(data.score);
    const [isBookmarked, setIsBookmarked] = useState(data.is_bookmarked);
    const simUpdateDate = convertDateToString("string", data.updated_at);

    
    useEffect(() => {
      setCountScore(data.count_score);
    }, [ratingValue]);

    const { run: toggleBookmark } = useAxios({
      url: toggleSimBookmarkApi + `${data.id}/`,
    });

    const handleBookMarked = () => {
      toggleBookmark().then((response) => {
        setIsBookmarked(response.data.is_bookmarked);
      });
    };

    const handleChangeRating = (newValue) => {
      setRatingValue(newValue);
      if (newValue === null) return;
      axios.get(`${rateSimApi}${data.id}/${newValue}/`);
    };

    return (
      <TabContentSection onClick={CheckAccessFunction}>
        <Container className="pt-5 pb-3">
          {isShowVideo ? (
            <VideoPlayerComponent
              videoSource={playingVideo.src}
              isSim
              enableAutoplay={isShowVideo && autoPlayer}
              poster={videoPoster}
              setShowFunciton={setIsShowVideo}
              hasTrack={!!data.subtitle}
              subtitleSource={data.subtitle}
              crossOrigin={playingVideo.crossOrigin}
            />
          ) : (
            <SimWrapper className="mb-5">
              <RightContent className="d-grid">
                <figure className="position-relative">
                  <img
                    src={data.image}
                    alt={data.name}
                    className="w-100 img-fluid"
                    width={370}
                    height={220}
                  />
                  {(data.device === 0 || data.sim_size === 1) && (
                    <div className="device-info position-absolute">
                      {data.sim_size === 1 && (
                        <StyledTooltip
                          title="با توجه به حجم شبیه‌ساز، برای مشاهده آن صبور باشید."
                          placement="top-end"
                        >
                          <>
                            <Timer color="white" size={18} className="icon" />
                          </>
                        </StyledTooltip>
                      )}
                      {data.device === 0 && (
                        <StyledTooltip
                          title="برای مشاهده این شبیه‌ساز از رایانه استفاده کنید."
                          placement="bottom-start"
                        >
                          <>
                            <Monitor color="white" size={18} className="icon" />
                          </>
                        </StyledTooltip>
                      )}
                    </div>
                  )}
                </figure>

                {bookData && bookData.page_start ? (
                  <StyledTooltip title="برو به کتاب درسی">
                    <>
                      <a
                        target="_blank"
                        href={`${bookData.book.path}#page=${bookData.page_start}`}
                        className="book-button py-3 w-100 border-0"
                        nodownload="true"
                      >
                        <span className="ms-1">{data.topic}</span>
                        <Book1 />
                      </a>
                    </>
                  </StyledTooltip>
                ) : (
                  <div className="book-button py-3 w-100 border-0">
                    <span className="ms-1">{data.topic}</span>
                    <Book1 />
                  </div>
                )}
                <SimHashtagFilterWrapper>
                  {hashtagList.map((hashtag) => {
                    return (
                      <HashtagLabel
                        key={hashtag.id}
                        as={Link}
                        to={`../sims?filter_hashtag__id__in=${hashtag.id}`}
                      >
                        {hashtag.name}
                      </HashtagLabel>
                    );
                  })}
                </SimHashtagFilterWrapper>
              </RightContent>
              <LeftContent>
                <Row>
                  <Col xs={10} lg={6}>
                    <h1 className="title d-inline mb-3">{data.name}</h1>
                    {data.is_free && (
                      <b className="free-label text-secondary me-2">
                        (آزمایش رایگان)
                      </b>
                    )}
                  </Col>
                  <Col xs={2} lg={2} className="text-start order-lg-4 pt-0 pt-lg-3">
                    {isBookmarked ? (
                      <StyledTooltip title="حذف از علاقه‌مندی‌ها">
                        <>
                          <Heart2
                            set="bold"
                            primaryColor="#F83C3C"
                            onClick={handleBookMarked}
                            className="bookmark-icon"
                          />
                        </>
                      </StyledTooltip>
                    ) : (
                      <StyledTooltip title="افزودن به علاقه‌مندی‌ها">
                        <>
                          <Heart
                            set="curved"
                            primaryColor="var(--deactive-color)"
                            onClick={handleBookMarked}
                            className="bookmark-icon"
                          />
                        </>
                      </StyledTooltip>
                    )}
                  </Col>
                  <Col xs={12} lg={6} className="order-lg-2 pt-3 pt-lg-0">
                    <CardScoreDiv className="d-flex justify-content-end text-muted">
                      <span>({countScore} رای)</span>
                      <b className="text-muted">{data.score?.toFixed(2)}</b>
                      {isLogin ? (
                        <StyledRating
                          dir="ltr"
                          name="lab-score"
                          value={ratingValue}
                          precision={1}
                          onChange={(event, newValue) => {
                            handleChangeRating(newValue);
                          }}
                        />
                      ) : (
                        <StyledRating
                          dir="ltr"
                          name="lab-score"
                          value={ratingValue}
                          precision={1}
                          readOnly
                        />
                      )}
                    </CardScoreDiv>
                  </Col>
                  <Col xs={12} lg={10} className="order-lg-3">
                    <ReactMarkdown className="description text-justify mt-3">
                      {data.description}
                    </ReactMarkdown>
                  </Col>
                </Row>
                <footer className="mt-4">
                  <h5 className="title mb-3">اهداف آزمایش</h5>
                  <ReactMarkdown className="sim-goals">{data.goal}</ReactMarkdown>
                </footer>
              </LeftContent>
            </SimWrapper>
          )}

          <VideosSelectionWrapper className="mt-5">
            {videosList.map((item) => {
              return (
                <VideoTemplate
                  key={item.id}
                  id={item.id}
                  title={item.title}
                  src={item.src}
                  isActive={playingVideo.activeVideo[item.id]}
                  crossOrigin={item.crossOrigin}
                />
              );
            })}
          </VideosSelectionWrapper>
          <BottomWrapper className="px-lg-5">
            {data.blog_link && (
              <a
                href={data.blog_link}
                alt="مشاهده مقاله"
                target="_blank"
                className="text-primary text-center"
              >
                مشاهده مقاله در بلاگ آزتو
              </a>
            )}
            <p className="text-center text-sm-start">
              آخرین ویرایش
              {` ${simUpdateDate.month}  ${simUpdateDate.year}`}
            </p>
          </BottomWrapper>
        </Container>
      </TabContentSection>
    );
  };
  let element = null;
  if (loading || !!data.length) {
    element = <InfoSkeleton />;
  } else if (error) {
    element = errorMessage;
  } else if (data.length !== 0) {
    element = <InfoSection />;
  }

  return element;
};

export default memo(SimInfoComponent);
